import List from "src/dataTypes/lists/List";
import Interval from "src/dataTypes/numeric/Interval";
import IntervalList from "src/dataTypes/numeric/IntervalList";
import ObjectOperators from "src/operators/objects/ObjectOperators";

/**
 * @classdesc Provides a set of tools that work with Interval Lists.
 *
 * @namespace
 * @category numbers
 */
function IntervalListOperators() {}
export default IntervalListOperators;


/**
 * @todo write docs
 */
IntervalListOperators.scaleIntervals = function(intervalList, value) {
	if(intervalList==null) return;

	value = value==null?1:value;

  var newIntervalList = new List();
  var l = intervalList.length;
  var i;

  newIntervalList.name = intervalList.name;

  for(i = 0; i<l; i++) {
    newIntervalList[i] = intervalList[i].getScaled(value);
  }

  return newIntervalList;
};


/**
 * returns a IntervalList from two NumberLists
 * @param  {NumberList} numberList0 first numberList
 * @param  {NumberList} numberList1 second numberList
 *
 * @param  {Boolean} bAmplitude if true then second numberList is treated as an amplitude instead of end value. (default: false)
 * @return {IntervalList}
 * tags:
 */
IntervalListOperators.numberListsToIntervalList = function(numberList0, numberList1, bAmplitude) {
  if(numberList0==null || numberList1==null) return;
  bAmplitude = bAmplitude ==  null ? false : bAmplitude;

  var l = Math.min(numberList0.length, numberList1.length);
  var i;
  var intervalList = new IntervalList();

  if(bAmplitude){
    numberList1 = ObjectOperators.addition(numberList0,numberList1);
  }
  for(i=0; i<l; i++){
    intervalList.push(new Interval(numberList0[i], numberList1[i]));
  }

  return intervalList;
};
